angular.module 'zc.master.projects'

.controller 'MasterProjectsListCtrl', (
    $filter,
    $q,
    $scope,
    $translate,
    Devise,
    Page,
    MasterProject,
    ProjectStats,
    currencies,
    SearchFilter) ->

  Page.setBodyClass ''
  $translate('masterProjects.list.siteList').then (translation) ->
    Page.setTitle translation

  $scope.projects = []
  $scope.filteredProjects = []

  $scope.filters = SearchFilter.resolveFromLocation()
  $scope.filters.product_line = 'all'
  $scope.filters.contract_status = 'all'

  $scope.project_status =
    all: $translate.instant('masterProjects.list.all')
    before_trial: $translate.instant('masterProjects.list.beforeTrial')
    trial: $translate.instant('masterProjects.list.trial')
    terminated_after_trial: $translate.instant('masterProjects.list.terminatedAfterTrial')
    contracted: $translate.instant('masterProjects.list.contracted')
    terminated_after_contract: $translate.instant('masterProjects.list.terminatedAfterContract')
    idle: $translate.instant('masterProjects.list.idle')

  $scope.table = false

  SearchFilter.setComponentDefaults('masterProjectsList', {
    visible_group:
      default: 'settings'
    sort_prop:
      default: 'apikey'
    sort_direction:
      default: 'desc'
  })

  $scope.$on '$destroy', () ->
    SearchFilter.removeComponentDefaults 'masterProjectsList'

  $scope.setVisibleGroup = (visibleGroup) ->
    $scope.filters.visible_group = visibleGroup
    SearchFilter.updateComponentDefaults 'masterProjectsList'
    $scope.updateData()

  $scope.setSortProp = (key) ->
    if $scope.filters.sort_prop == key
      if $scope.filters.sort_direction = 'desc'
        $scope.filters.sort_direction = 'asc'
      else
        $scope.filters.sort_direction = 'desc'
    else
      $scope.filters.sort_prop = key
      $scope.filters.sort_direction = 'desc'
    $scope.filterProjects()

  $scope.filterProjects = () ->
    sortDirectionReverse = ($scope.filters.sort_direction == 'desc')
    $scope.filteredProjects = $filter("projectText")($scope.projects, $scope.filters.search_term)

    $scope.filteredProjects = filterByProductLine $scope.filteredProjects, $scope.filters.product_line
    $scope.filteredProjects = filterByProjectStatus $scope.filteredProjects, $scope.filters.contract_status

    $scope.filteredProjects = $filter('orderBy')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse)
    $scope.filteredProjects = $filter('emptyToEnd')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse)

    SearchFilter.set $scope.filters
    SearchFilter.updateComponentDefaults 'masterProjectsList'

  $scope.updateData = () ->
    SearchFilter.set $scope.filters
    apikeys = _.map $scope.projects, (p) -> p.apikey
    if $scope.filters.visible_group is "stats"
      ProjectStats.getDailyProjectStats
        apikey: $in: apikeys
        start_at:
          $gte: moment($scope.filters.start_at).toDate()
          $lt: moment($scope.filters.end_at).add(1, 'day').toDate()
      .then (res) ->
        for project in $scope.projects
          project.stats = res[project.apikey]
        $scope.filterProjects()
    else
      $scope.filterProjects()
    _.each $scope.projects, (project) ->
      project.currencyObj = currencies[project.currency]

  $scope.checkIsAssignee = (project) ->
    Devise.currentUser.email in (user.email for user in project.users)

  $scope.assignCurrentUser = (project) ->
    MasterProject.assign
      projectId: project.id
    ,
      userId: Devise.currentUser.id
    .then ->
      project.users.push Devise.currentUser
      project.isAssignee = $scope.checkIsAssignee(project)

  $scope.unassignCurrentUser = (project) ->
    MasterProject.unassign
      projectId: project.id
    ,
      userId: Devise.currentUser.id
    .then ->
      _.remove project.users, (user) ->
        user.email is Devise.currentUser.email
      project.isAssignee = $scope.checkIsAssignee(project)

  $q.when MasterProject.all(), (projects) ->
    $q.when MasterProject.addInterestTreeStatus(projects), (projects) ->
      $scope.projects = projects
      $scope.filterProjects()

      $scope.updateData()

  filterByProductLine = (projects, productLine) ->
    _.filter projects, (project) ->
      return true if productLine == 'all'
      project.product_line == productLine

  filterByProjectStatus = (projects, status) ->
    _.filter projects, (project) ->
      return true if status == 'all'
      project.contract_status == status

  $scope.resetSearchTerm = () ->
    $scope.filters.search_term = ""
    $scope.filterProjects()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.projects/list.controller.js.coffee